import React, { useState } from 'react';
import { NEWS_INTEREST_CATEGORIES } from '../constants/newsInterests';
import './NewsInterestSelector.css';

interface Props {
  selectedInterests: string[];
  onChange: (interests: string[]) => void;
}

const NewsInterestSelector: React.FC<Props> = ({ selectedInterests, onChange }) => {
  const [expandedCategories, setExpandedCategories] = useState<Set<string>>(new Set());

  const toggleCategory = (name: string) => {
    setExpandedCategories((prev) => {
      const next = new Set(prev);
      if (next.has(name)) {
        next.delete(name);
      } else {
        next.add(name);
      }
      return next;
    });
  };

  const toggleInterest = (slug: string) => {
    if (selectedInterests.includes(slug)) {
      onChange(selectedInterests.filter((s) => s !== slug));
    } else {
      onChange([...selectedInterests, slug]);
    }
  };

  return (
    <div className="interest-selector">
      <label className="interest-selector-label">News Interests</label>
      {NEWS_INTEREST_CATEGORIES.map((cat) => (
        <div key={cat.name} className="interest-category">
          <button
            type="button"
            className="interest-category-header"
            onClick={() => toggleCategory(cat.name)}
          >
            <span className="interest-category-arrow">
              {expandedCategories.has(cat.name) ? '\u25BC' : '\u25B6'}
            </span>
            <span>{cat.name}</span>
            <span className="interest-category-count">
              {cat.subcategories.filter((s) => selectedInterests.includes(s.slug)).length}/{cat.subcategories.length}
            </span>
          </button>
          {expandedCategories.has(cat.name) && (
            <div className="interest-subcategories">
              {cat.subcategories.map((sub) => (
                <label key={sub.slug} className="interest-checkbox">
                  <input
                    type="checkbox"
                    checked={selectedInterests.includes(sub.slug)}
                    onChange={() => toggleInterest(sub.slug)}
                  />
                  <span>{sub.label}</span>
                </label>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default NewsInterestSelector;
